import useSelectedTourIds from "@/onboarding/features/bidding/hooks/useSelectedTourIds"
import { currentPermissionState } from "@/onboarding/features/bidding/models/fieldStates"
import {
  FieldSetting,
  FieldSettingWithCurrentState,
  PermissionFlag,
  TourFieldPermissions,
} from "@/onboarding/features/bidding/types"

const useFieldStates = (
  pickedSettings: FieldSetting[],
  tours: { input: string; permissions: TourFieldPermissions[] }
) => {
  const selectedIds = useSelectedTourIds(tours.input)
  const selectedTours = tours.permissions.filter((tour) => selectedIds.includes(tour.tourId))

  const currentValue = (fieldName: string, permissionFlag: PermissionFlag) =>
    currentPermissionState(selectedTours, fieldName, permissionFlag).value

  const displayRows: FieldSettingWithCurrentState[] = pickedSettings.map((pickedSetting) => ({
    ...pickedSetting,
    writeable:
      pickedSetting.writeable ?? currentValue(pickedSetting.name, PermissionFlag.WRITEABLE),
    required: pickedSetting.required ?? currentValue(pickedSetting.name, PermissionFlag.REQUIRED),
    pickedSetting,
  }))

  return { selectedTours, displayRows }
}

export default useFieldStates
